import { useEffect } from 'react';

const useKeydown = callback => {
  useEffect(() => {
    const handleKeydown = event => {
      callback(event);
    };

    document.addEventListener('keydown', handleKeydown);
    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [callback]);
};

export default useKeydown;
